@if (shouldDisplay()) {
<!-- Bottom Left Version Display -->
@if (isHome()) {
<div class="app-version-bottom-left">
  {{ version }}
</div>

<!-- Desktop Footer -->
<footer class="footer desktop-footer">
  <div class="footer-container">
    <p class="footer-text">{{ version }}</p>
  </div>
</footer>
}

<!-- Instagram-like Mobile Footer -->
<footer class="mobile-footer">
  <div class="mobile-footer-container">
    <!-- @if (isHome()) {
      <span class="mobile-version-text">{{ version }}</span>
    } -->
    @if (isLeadTrack()) {
    <button type="button" class="footer-item footer-menu-btn" (click)="toggleLeadTrackMenu()" aria-label="Toggle Lead Track Menu">
      <div class="footer-icon-wrapper">
        <span class="material-symbols-outlined">menu</span>
      </div>
      <span class="footer-label">Menu</span>
    </button>
    }
    <a routerLink="/home" routerLinkActive="active" class="footer-item">
      <div class="footer-icon-wrapper">
        <span class="material-symbols-outlined">home</span>
      </div>
      <span class="footer-label">Home</span>
    </a>
    <a routerLink="/main-chat" routerLinkActive="active" class="footer-item">
      <div class="footer-icon-wrapper">
        <span class="material-symbols-outlined">chat</span>
        @if (unreadCount$ | async; as totalUnreadCount) {
        <span class="badge" [ngClass]="{'d-none': totalUnreadCount === 0}">
          {{ totalUnreadCount > 99 ? '99+' : totalUnreadCount }}
        </span>
        }
      </div>
      <span class="footer-label">Chat</span>
    </a>
  </div>
</footer>
}